import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

const environment = process.env.REACT_APP_ENV;
const tracesSampleRate = environment === 'development' ? 1 : 0.1;
if (!!environment && environment !== 'local') {
	Sentry.init({
		dsn: 'https://1737649843434c0e84d365c0585d1905@o1100672.ingest.sentry.io/6125992',
		integrations: [new TracingIntegrations.BrowserTracing()],
		// Sample rate is the % of random transaction samples which will be sent to Sentry
		tracesSampleRate,
		environment,
	});
}
